module.exports = __webpack_public_path__ + "menu-out.ce02aec8009f9c0fa650c1ab5f5a9485.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-out.svg
// module id = 1144
// module chunks = 0